var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"kt_header",staticClass:"header",class:_vm.headerClasses,attrs:{"id":"kt_header"}},[_c('div',{staticClass:"container-fluid d-flex align-items-center justify-content-end"},[_c('KTTopbar')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }